<template>
  <TrfModal
    v-if="isAtivo"
    idModal="modal-excluir-tarefa"
    :titulo="titulo"
    btnSaveName="Confirmar"
    :isBtnLoading="isLoading"
    @save="handleConfirmar"
    @close="handleFechar"
    v-e2e="'modal-excluir-tarefa'"
  >
    <p v-html="textoExclusaoSanitizado"></p>
  </TrfModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import DOMPurify from 'dompurify';

export default {
  name: 'TrfModalExcluirTarefa',
  components: {
    TrfModal: defineAsyncComponent(() => import('../index.vue'))
  },
  props: {
    isAtivo: {
      type: Boolean,
      required: true
    },
    tarefa: {
      type: Object,
      required: true
    },
    textoExclusao: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      default: 'Excluir tarefa'
    }
  },
  emits: ['confirmar', 'fechar'],
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    textoExclusaoSanitizado() {
      return DOMPurify.sanitize(this.textoExclusao);
    }
  },
  methods: {
    handleConfirmar() {
      this.isLoading = true;
      this.$emit('confirmar', this.tarefa);
    },
    handleFechar() {
      this.isLoading = false;
      this.$emit('fechar');
    }
  },
  watch: {
    isAtivo(novoValor) {
      if (!novoValor) {
        this.isLoading = false;
      }
    }
  }
};
</script>
